import { generateOpenApi } from '@ts-rest/open-api';
import { teamsContract } from './teams.contract.js';

export const teamsOpenApiSpec = generateOpenApi(
  teamsContract,
  {
    info: {
      title: 'Skewb Works Teams API',
      version: '1.0.0',
      description:
        'Type-safe teams API for Skewb Works Lite. Covers CRUD operations, member management, and utilization tracking.',
      contact: {
        name: 'Skewb Works Development Team',
      },
    },
    servers: [
      {
        url: 'https://localhost:8080',
        description: 'Local development server',
      },
      {
        url: 'https://api.works-works-lite.dev.skewbdigital.co.uk',
        description: 'Dev API server',
      },
    ],
    tags: [
      {
        name: 'Teams',
        description: 'Team management, members, and utilization endpoints',
      },
    ],
  },
  {
    setOperationId: true,
    operationMapper: (operation) => ({
      ...operation,
      tags: ['Teams'],
    }),
  },
);
